import { render } from "./CertificatePending.vue?vue&type=template&id=7b393241&scoped=true"
import script from "./CertificatePending.vue?vue&type=script&lang=js"
export * from "./CertificatePending.vue?vue&type=script&lang=js"

import "./CertificatePending.vue?vue&type=style&index=0&id=7b393241&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b393241"]])

export default __exports__